<template lang="pug">
  .store-activity-panel
    .header
      h4.header-title
        slot(name="header")
      span.header-edit(v-show="showEdit" @click="$emit('update:show', !show)")
        | {{ show ? 'Close' : 'Edit' }}
        icon.collapse-icon(name="angle-up" :class="{'expand': !show}")
    transition(name="grow")
      .body(v-show="show")
        slot(name="body")
</template>

<script>
import 'vue-awesome/icons/angle-up'

export default {
  name: 'StoreActivityPanel',
  props: {
    header: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
    showEdit: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/bodies';

$anim-time: 0.4s;
$body-height: 18rem;

.store-activity-panel {
  border: 2px solid #f2f2f2;

  .header {
    display: flex;
    padding: 0.5rem 1rem;

    .header-title {
      flex-grow: 1;
    }

    .header-edit {
      flex-grow: 0;
      @extend .body-1;
      color: #7c3a74;
      cursor: pointer;
      vertical-align: middle;

      .collapse-icon {
        width: 1rem;
        height: 1.4rem;
        vertical-align: middle;
        transition: transform $anim-time;
        position: relative;
        top: -1px;
      }

      .collapse-icon.expand {
        transform: rotate(180deg);
        transition: transform $anim-time;
      }
    }
  }

  .body {
    padding: 1rem;
    background-color: #f2f2f2;
    max-height: $body-height;
    height: $body-height;
    overflow-y: hidden;
  }

  .grow-enter-active,
  .grow-leave-active {
    transition: max-height $anim-time, padding-top $anim-time,
      padding-bottom $anim-time;
  }

  .grow-enter,
  .grow-leave-to {
    max-height: 0px;
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
